import React, { useState, useEffect } from "react";

import { Grid, Typography, Avatar } from "@material-ui/core";

export default (props) => {
    const [profile, setProfile] = useState(props.profile);
    const [report, setReport] = useState(props.report);
    const [toolboxTypes, setToolboxTypes] = useState(props.toolboxTypes);

    useEffect(() => {
        setProfile(props.profile);
        setReport(props.report);
        setToolboxTypes(props.toolboxTypes);
    }, [props.profile, props.toolboxTypes, props.report]);

    const renderText = (label, key, multiline = false) => {
        return (
            <div
                style={{
                    display: "flex",
                    marginBottom: 30,
                    marginLeft: 24,
                }}
            >
                <Typography style={{ width: 200 }} variant="title">
                    <b>{label}:</b>
                </Typography>
                <Typography style={{ marginLeft: 24 }} variant="subheading">
                    {profile[key]}
                </Typography>
            </div>
        );
    };
    const renderDropDown = (label, key, opts) => {
        return (
            <div
                style={{
                    display: "flex",
                    marginBottom: 30,
                    marginLeft: 24,
                }}
            >
                <Typography style={{ width: 200 }} variant="title">
                    <b>{label}:</b>
                </Typography>
                <Typography style={{ marginLeft: 40 }} variant="subheading">
                    {!profile[key]
                        ? ""
                        : typeof profile[key] === "object"
                        ? profile[key].map((e) => {
                              return <span>{e + ", "}</span>;
                          })
                        : profile[key]}
                </Typography>
            </div>
        );
    };

    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Toolbox Talk Details:
            </Typography>

            <Avatar
                style={{
                    width: 100,
                    height: 100,
                    marginLeft: 24,
                    borderRadius: "12px",
                    border: "2px solid #0188cc",
                    marginBottom: 24,
                }}
                variant="rounded"
                src={profile.icon_url}
                alt=""
            />

            {renderText("Topic Name", "toolbox_topic", false)}
            {renderDropDown("Category", "category", toolboxTypes)}
            <div
                style={{
                    display: "flex",
                    marginBottom: 30,
                    marginLeft: 24,
                }}
            >
                <Typography style={{ width: 200 }} variant="title">
                    <b>Start Date/Time:</b>
                </Typography>
                <Typography style={{ marginLeft: 40 }} variant="subheading">
                    {report.start_timestamp || "N/A"}
                </Typography>
            </div>
            <div
                style={{
                    display: "flex",
                    marginBottom: 30,
                    marginLeft: 24,
                }}
            >
                <Typography style={{ width: 200 }} variant="title">
                    <b>End Date/Time:</b>
                </Typography>
                <Typography style={{ marginLeft: 40 }} variant="subheading">
                    {report.end_timestamp || "N/A"}
                </Typography>
            </div>
            <div
                style={{
                    display: "flex",
                    marginBottom: 30,
                    marginLeft: 24,
                }}
            >
                <Typography style={{ width: 200 }} variant="title">
                    <b>Toolbox Presenter:</b>
                </Typography>
                <Typography style={{ marginLeft: 40 }} variant="subheading">
                    {report.presented_by.user_name || "N/A"}
                </Typography>
            </div>
        </Grid>
    );
};
